var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Import the needed libraries.
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';
(function ($) {
    $(function () {
        // abort if we have no google map container
        if ($('.google-maps-container').length < 1) {
            return;
        }
        // set options for the google api
        setOptions({
            key: window.BCB.maps_api,
            v: 'weekly',
        });
        // do this for every google maps instance
        $('.google-maps-container').each(function (i_, el) {
            var mapContainer = el;
            if (!(mapContainer instanceof HTMLElement))
                throw new Error('no container element found');
            var $googleMap = $(mapContainer).find('#google-map');
            // build google map after blocker was unblocked
            $googleMap.on('unblocked', function () {
                makeGoogleMap(mapContainer);
            });
        });
        function makeGoogleMap(container) {
            return __awaiter(this, void 0, void 0, function () {
                var Map, Marker, lat, lng, latlng, styles, styledMap, mapOptions, map;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, importLibrary('maps')];
                        case 1:
                            Map = (_a.sent()).Map;
                            return [4 /*yield*/, importLibrary('marker')
                                // creat a location
                            ];
                        case 2:
                            Marker = (_a.sent()).Marker;
                            lat = Number(container.getAttribute('data-lat'));
                            lng = Number(container.getAttribute('data-lng'));
                            latlng = { lat: lat, lng: lng };
                            styles = [
                                { stylers: [{ saturation: -100 }, { lightness: 0 }] },
                                // {
                                // 	featureType: "road",
                                // 	stylers: [{ hue: "#ffbb00" }, { saturation: 36 }]
                                // },
                                { featureType: 'water', stylers: [{ saturation: -100 }] },
                                { featureType: 'poi', stylers: [{ visibility: 'off' }] },
                            ];
                            styledMap = new google.maps.StyledMapType(styles, {
                                name: 'Styled Map',
                            });
                            mapOptions = {
                                zoom: 16,
                                scrollwheel: false,
                                center: latlng,
                                panControl: false,
                                mapTypeControl: false,
                                scaleControl: false,
                                streetViewControl: false,
                                overviewMapControl: false,
                            };
                            map = new Map(container.querySelector('.mapholder'), mapOptions);
                            // add the marker to map
                            addMarker(latlng, container, map, Marker);
                            // Associate the styled map with the MapTypeId and set it to display.
                            map.mapTypes.set('map_style', styledMap);
                            map.setMapTypeId('map_style');
                            return [2 /*return*/];
                    }
                });
            });
        }
        function addMarker(latlng, mapContainer, Map, Marker) {
            return __awaiter(this, void 0, void 0, function () {
                var marker, link, linkObj_1;
                return __generator(this, function (_a) {
                    marker = new Marker({
                        position: latlng,
                        title: 'BCB Body Clinic',
                        icon: window.BCB.theme_url + '/public/img/location-pin.svg',
                        Map: Map,
                    });
                    link = mapContainer.getAttribute('link');
                    if (link) {
                        linkObj_1 = JSON.parse(link);
                        // set the title
                        if (linkObj_1.title && linkObj_1.title.length > 0) {
                            marker.setTitle(linkObj_1.title);
                        }
                        // set the url
                        if (linkObj_1.url && linkObj_1.url.length > 0) {
                            // add eventlistener for opening the linkObj
                            marker.addListener('click', function () {
                                if (linkObj_1.target === '_blank') {
                                    window.open(linkObj_1.url);
                                }
                                else {
                                    window.location.href = linkObj_1.url;
                                }
                            });
                        }
                    }
                    return [2 /*return*/];
                });
            });
        }
    });
})(jQuery);
